import React from 'react';
import { CheckCircle, Users, Mic, TrendingUp } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const features = [
{ icon: Mic, text: 'Daily structured speaking practice' },
{ icon: TrendingUp, text: '90-day fluency transformation system' },
{ icon: Users, text: 'Live coaching with Coach Ravi' },
{ icon: CheckCircle, text: 'Community accountability & support' }];


const stats = [
{ value: '4,200+', label: 'Active Learners' },
{ value: '94%', label: 'Confidence Gain' },
{ value: '4.9/5', label: 'Rating' }];


export default function AuthBrandPanel() {
  return (
    <div className="w-full gradient-hero flex flex-col justify-between p-10 xl:p-14">
      {/* Logo */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl gradient-green flex items-center justify-center text-white font-extrabold text-lg shadow-glow-green">
          FE
        </div>
        <div className="flex flex-col leading-tight">
          <span className="font-bold text-sm text-white leading-none">Fluent English</span>
          <span className="text-xs text-primary-light leading-none font-semibold">Blueprint</span>
        </div>
      </div>
      {/* Main content */}
      <div className="flex flex-col gap-8">
        <div>
          <h2 className="text-3xl xl:text-4xl font-extrabold text-white leading-tight mb-4">
            Speak Fluent English
            <br />
            <span className="hero-text-gradient">in 90 Days</span>
          </h2>
          <p className="text-white/70 text-base leading-relaxed">
            No Grammar Confusion. No Hesitation. No Fear.
            <br />
            Join Coach Ravi's proven fluency transformation system.
          </p>
        </div>

        {/* Features */}
        <div className="flex flex-col gap-3">
          {features?.map((feat) => {
            const Icon = feat?.icon;
            return (
              <div key={`auth-feat-${feat?.text}`} className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center flex-shrink-0">
                  <Icon size={15} className="text-primary-light" />
                </div>
                <span className="text-sm font-medium text-white/85">{feat?.text}</span>
              </div>);

          })}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-3">
          {stats?.map((stat) =>
          <div
            key={`auth-stat-${stat?.label}`}
            className="text-center p-3 rounded-xl bg-white/10 border border-white/15">

              <p className="text-xl font-extrabold text-white font-tabular">{stat?.value}</p>
              <p className="text-xs text-white/60 font-medium mt-0.5">{stat?.label}</p>
            </div>
          )}
        </div>

        {/* Testimonial snippet */}
        <div className="p-4 rounded-2xl bg-white/10 border border-white/20">
          <p className="text-sm text-white/85 italic leading-relaxed mb-3">
            "After 45 days in the Blueprint, I gave a full presentation to 20 people at my company.
            My manager said it was the best I'd ever done."
          </p>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-purple-500 flex items-center justify-center text-white text-xs font-bold">
              PV
            </div>
            <div>
              <p className="text-xs font-bold text-white">Priya Venkatesh</p>
              <p className="text-xs text-white/60">Software Engineer, Bengaluru</p>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <p className="text-xs text-white/40">
        © 2026 Fluent English Blueprint · Coach Ravi
      </p>
    </div>);

}